// document.addEventListener("DOMContentLoaded", function () {
//   const accordionHeaders = document.querySelectorAll(".accordion-header");
//   let currentlyActive = document.querySelector(".accordion.active");

//   // Set initial heights for active accordion
//   if (currentlyActive) {
//     const activeContent = currentlyActive.querySelector(".accordion-content");
//     activeContent.style.maxHeight = activeContent.scrollHeight + "px";
//   }

//   function toggleAccordion(accordion) {
//     const isActive = accordion.classList.contains("active");
//     const button = accordion.querySelector(".accordion-header");
//     const content = accordion.querySelector(".accordion-content");

//     // If clicking the already active accordion, close it
//     if (accordion === currentlyActive) {
//       content.style.maxHeight = "0px";
//       accordion.classList.remove("active");
//       button.setAttribute("aria-expanded", "false");
//       currentlyActive = null;
//       return;
//     }

//     // Close the currently active accordion
//     if (currentlyActive) {
//       const activeContent = currentlyActive.querySelector(".accordion-content");
//       const activeButton = currentlyActive.querySelector(".accordion-header");
//       activeContent.style.maxHeight = "0px";
//       currentlyActive.classList.remove("active");
//       activeButton.setAttribute("aria-expanded", "false");
//     }

//     // Open the clicked accordion
//     accordion.classList.add("active");
//     button.setAttribute("aria-expanded", "true");
//     content.style.maxHeight = content.scrollHeight + "px";
//     currentlyActive = accordion;
//   }

//   accordionHeaders.forEach((header) => {
//     header.addEventListener("click", function () {
//       toggleAccordion(this.parentElement);
//     });

//     // Add keyboard navigation
//     header.addEventListener("keydown", function (e) {
//       if (e.key === "Enter" || e.key === " ") {
//         e.preventDefault();
//         toggleAccordion(this.parentElement);
//       }

//       // Arrow key navigation between accordion items
//       if (e.key === "ArrowDown" || e.key === "ArrowUp") {
//         e.preventDefault();
//         const accordions = Array.from(
//           document.querySelectorAll(".accordion-header")
//         );
//         const currentIndex = accordions.indexOf(this);
//         let nextIndex;

//         if (e.key === "ArrowDown") {
//           nextIndex =
//             currentIndex < accordions.length - 1 ? currentIndex + 1 : 0;
//         } else {
//           nextIndex =
//             currentIndex > 0 ? currentIndex - 1 : accordions.length - 1;
//         }

//         accordions[nextIndex].focus();
//       }

//       // Home and End keys
//       if (e.key === "Home") {
//         e.preventDefault();
//         accordionHeaders[0].focus();
//       }

//       if (e.key === "End") {
//         e.preventDefault();
//         accordionHeaders[accordionHeaders.length - 1].focus();
//       }
//     });
//   });

//   // Handle window resize to adjust heights
//   window.addEventListener("resize", function () {
//     if (currentlyActive) {
//       const content = currentlyActive.querySelector(".accordion-content");
//       // Remove transition temporarily for instant resize
//       content.style.transition = "none";
//       content.style.maxHeight = content.scrollHeight + "px";
//       // Force reflow
//       content.offsetHeight;
//       // Restore transition
//       content.style.transition = "";
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const accordionGroups = document.querySelectorAll(".accordion-group");

  accordionGroups.forEach((group) => {
    const headers = group.querySelectorAll(".accordion-header");
    let currentlyActive = group.querySelector(".accordion.active");

    // Set initial height for active accordion in THIS group
    if (currentlyActive) {
      const content = currentlyActive.querySelector(".accordion-content");
      content.style.maxHeight = content.scrollHeight + "px";
    }

    function toggleAccordion(accordion) {
      const isActive = accordion.classList.contains("active");
      const button = accordion.querySelector(".accordion-header");
      const content = accordion.querySelector(".accordion-content");

      // Close if clicking the active one
      if (accordion === currentlyActive) {
        content.style.maxHeight = "0px";
        accordion.classList.remove("active");
        button.setAttribute("aria-expanded", "false");
        currentlyActive = null;
        return;
      }

      // Close previously active accordion in this group
      if (currentlyActive) {
        const activeContent =
          currentlyActive.querySelector(".accordion-content");
        const activeButton =
          currentlyActive.querySelector(".accordion-header");

        activeContent.style.maxHeight = "0px";
        currentlyActive.classList.remove("active");
        activeButton.setAttribute("aria-expanded", "false");
      }

      // Open new accordion
      accordion.classList.add("active");
      button.setAttribute("aria-expanded", "true");
      content.style.maxHeight = content.scrollHeight + "px";
      currentlyActive = accordion;
    }

    headers.forEach((header, index) => {
      header.addEventListener("click", () => {
        toggleAccordion(header.parentElement);
      });

      header.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleAccordion(header.parentElement);
        }

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault();
          const nextIndex =
            e.key === "ArrowDown"
              ? (index + 1) % headers.length
              : (index - 1 + headers.length) % headers.length;

          headers[nextIndex].focus();
        }

        if (e.key === "Home") {
          e.preventDefault();
          headers[0].focus();
        }

        if (e.key === "End") {
          e.preventDefault();
          headers[headers.length - 1].focus();
        }
      });
    });

    // Resize handling per group
    window.addEventListener("resize", () => {
      if (currentlyActive) {
        const content =
          currentlyActive.querySelector(".accordion-content");
        content.style.transition = "none";
        content.style.maxHeight = content.scrollHeight + "px";
        content.offsetHeight;
        content.style.transition = "";
      }
    });
  });
});

